import { chaveStatusProducaoItem } from "../constants/status";
import { IResultadoAlteracaoPrensa } from "../interfaces/IAcoesLote";
import { IItemLote } from "../interfaces/IItemLote";

const FORNECEDOR_CONTINENTAL = "continental";
const PRODUCAO_ELEGIVEL = ["PENDENTE", "FALHA_PRENSA"];

export function loteContinental(
  itens: Pick<IItemLote, "fornecedor">[]
): boolean {
  return itens[0]?.fornecedor === FORNECEDOR_CONTINENTAL;
}

export function elegivelParaAlterarPrensa({
  statusProducao,
}: Pick<IItemLote, "statusProducao">): boolean {
  return (
    statusProducao === null ||
    PRODUCAO_ELEGIVEL.includes(chaveStatusProducaoItem(statusProducao))
  );
}

export function nadaAlterado({
  alteradas,
  falhas,
}: IResultadoAlteracaoPrensa): boolean {
  return alteradas + falhas === 0;
}

export function mensagemAlteracaoPrensa({
  alteradas,
  falhas,
  ignoradas,
}: IResultadoAlteracaoPrensa): string {
  let mensagem = `${alteradas} placa(s) com a prensa alterada`;

  if (falhas) {
    mensagem += `, ${falhas} com falha na Continental (veja a Observação)`;
  }

  if (ignoradas) {
    mensagem += `, ${ignoradas} ignorada(s)`;
  }

  return mensagem;
}
